"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarouselWidget = void 0;
var React = require("react");
var TypeStyle = require("typestyle");
var Icons_1 = require("../../icons/Icons");
var SharedWidgets_1 = require("../../SharedWidgets");
var DomWidgets_1 = require("../DomWidgets");
var CarouselStyleName = TypeStyle.style({
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
});
var ButtonStyleName = TypeStyle.style({
    height: 30,
    width: 30,
});
function buttonIconFactory(icon) {
    return function (state) { return React.createElement(DomWidgets_1.Img, { draggable: false, height: icon.height, src: Icons_1.encodeSvg(icon.icon(state)), width: icon.width }); };
}
var DynamicLeftArrowIcon = buttonIconFactory(Icons_1.StepperLeftIcon);
var DynamicRightArrowIcon = buttonIconFactory(Icons_1.StepperRightIcon);
// tslint:disable-next-line:max-line-length
exports.CarouselWidget = function (_a) {
    var children = _a.children, id = _a.id, nextButtonTitle = _a.nextButtonTitle, onNextClick = _a.onNextClick, onPreviousClick = _a.onPreviousClick, prevButtonTitle = _a.prevButtonTitle, role = _a.role, style = _a.style;
    var _b = React.useState(false), focusWithin = _b[0], setFocusWithin = _b[1];
    var prevMonthButton = React.createElement(SharedWidgets_1.ButtonWidget, { buttonType: SharedWidgets_1.ButtonType.Icon, className: ButtonStyleName, getContent: DynamicLeftArrowIcon, handleClick: onPreviousClick, testId: 'stepper-left', title: prevButtonTitle });
    var nextMonthButton = React.createElement(SharedWidgets_1.ButtonWidget, { buttonType: SharedWidgets_1.ButtonType.Icon, className: ButtonStyleName, getContent: DynamicRightArrowIcon, handleClick: onNextClick, testId: 'stepper-right', title: nextButtonTitle });
    return (React.createElement("div", { className: CarouselStyleName, onBlur: function () { return setFocusWithin(false); }, onFocus: function () { return setFocusWithin(true); }, style: style },
        prevMonthButton,
        React.createElement("span", { id: id, role: role, "aria-live": focusWithin ? 'assertive' : 'off', "aria-atomic": true }, children),
        nextMonthButton));
};
//# sourceMappingURL=CarouselWidget.js.map